import Collapse from "./Collapse";
export default Collapse;

/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */
var Panel = Collapse.Panel;
export { Panel };


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-collapse/es/index.js
// module id = 1116
// module chunks = 0